module.exports = __webpack_public_path__ + "static/media/thumb.1e91fb4a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/willow-walk-extension/thumb.jpg
// module id = 49
// module chunks = 0